import { Injectable } from '@angular/core';
import { sanitizeRichText } from '../../sanitize-rich-text/sanitize-rich-text.function';
import { encodeTextToHtml } from '../../encode-text-to-html/encode-text-to-html';

@Injectable({
  providedIn: 'root',
})
export class HtmlSanitizer {
  sanitizeRichText(richText: string): string {
    return sanitizeRichText(richText);
  }

  encodeTextToHtml(text: string): string {
    return encodeTextToHtml(text);
  }
}
